import _ from 'lodash';

// This CacheRegistry is a utility class can be used to easily keep track of cached values.
// it will call the data loader if the data does not already exist in the cache
// example usage
// let cache = new CacheRegistry();
// return cache.get('data-item', () => { return 'loaded-data-item-to-cache' });

export default class CacheRegistry {

  constructor() {
    this._cache = new Map();
  }

  clearAll() {
    this._cache.clear();
  }

  has(key) {
    let nkey = this._normalizeKey(key);
    return this._cache.has(nkey);
  }

  get(key, fnLoaderOrValue = undefined) {
    let nkey = this._normalizeKey(key);
    if (!this._cache.has(nkey)) {
      let val = undefined;
      if (fnLoaderOrValue !== undefined) {
        val = _.isFunction(fnLoaderOrValue)? fnLoaderOrValue(): fnLoaderOrValue;
        this._cache.set(nkey, val);
      }
      return val;
    }
    return this._cache.get(nkey);
  }

  set(key, val) {
    let nkey = this._normalizeKey(key);
    return this._cache.set(nkey, val);
  }

  remove(key) {
    let nkey = this._normalizeKey(key);
    return this._cache.delete(nkey);
  }

  _normalizeKey(key) {
    return key;
  }

}


